<script lang="ts" setup>
import Checkbox, {
  type CheckboxEmits,
  type CheckboxProps,
  type CheckboxSlots,
} from 'primevue/checkbox'

interface Props extends /* @vue-ignore */ CheckboxProps {
  error?: boolean
  binary?: CheckboxProps['binary']
}
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface Emits extends /* @vue-ignore */ CheckboxEmits {}
withDefaults(defineProps<Props>(), { binary: true })
defineEmits<Emits>()

const model = defineModel<Props['modelValue'] | null>()

const errorInjected = inject<Ref<boolean>>('error', ref(false))

const slots = defineSlots<CheckboxSlots>()
</script>

<template>
  <Checkbox
    v-bind="$props"
    v-model="model"
    :invalid="errorInjected || error"
  >
    <template
      v-for="(_, slot) in slots"
      #[slot]="slotData"
    >
      <slot
        :name="slot"
        v-bind="slotData"
      />
    </template>
  </Checkbox>
</template>
